import React from "react";
import { Tooltip, IconButton } from "@hiver/hiver-ui-kit";
import SVGInline from "react-svg-inline";
import timerIcons from "../../../common/images/timer.svg";
import whiteTimerIcons from "../../../common/images/whiteTimer.svg";

const TimerIcon = ({timerIconStyle = {}, iconSize = '16px', tooltipProps = {}, isDarkTheme = false, noTooltip = false }) => {
    const timerIconButtonStyle = {
        lineHeight: 0, 
        height: 'max-content',
        '&:hover': {
            backgroundColor: 'transparent'
        },
        ...timerIconStyle        
    }

    const {
        title = 'On 14 day trial',
        placement = 'bottom'
    } = tooltipProps

    if (noTooltip) {
        return (
            <IconButton sx={timerIconButtonStyle} className='onExploringHigherPlanIcon'>
                <SVGInline svg={isDarkTheme ? whiteTimerIcons : timerIcons} width={iconSize} height={iconSize} />
            </IconButton>
        )
    }

    return (
        <Tooltip title={title} placement={placement} arrow>
            <IconButton sx={timerIconButtonStyle} className='onExploringHigherPlanIcon'>
                <SVGInline svg={isDarkTheme ? whiteTimerIcons : timerIcons} width={iconSize} height={iconSize} />
            </IconButton>
        </Tooltip>
    )
}

export default TimerIcon